<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :disabled="selDisabled"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'isDisabled'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/reward_profiles')
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: b.name };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  },
  computed: {
    selDisabled() {
      return this.isDisabled == true;
    }
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
